export default __webpack_public_path__ + "static/media/sample.2cb8692f.jpg";